import React, { PropTypes } from 'react';

const utslapp = ({value}) => {
    

const desk = require("./img/diagramdesk.gif");
const mob = require("./img/diagrammob.gif");  


    
  const style = require('./utslapp.scss');
  return (
    <div>
      
      <div className={style.picS} style={{backgroundImage: 'url("'+ mob + '")'}}></div>
      <div className={style.picM} style={{backgroundImage: 'url("'+ desk + '")'}}></div>
      <p className={style.kalla}> Källa: Teknikens värld</p>
      </div>
  );
};

export default utslapp;




/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Special/utslapp/utslapp.js
 **/